import React from 'react'

import { API } from 'services';

import { AbstractContainer } from 'containers';

import { ClinicListScene } from 'scenes';

class ClinicListContainer extends AbstractContainer {

  getTasks() {

    return [
      {
        group: 1,
        key: 'clinics',
        exec: (done, failure) => {
          API.get('clinics')
          .then((response) => {

            Promise.all(response.data.map((clinic) => {
              return new Promise((resolve, reject) => {
                Promise.resolve(API.get('clinics/' + clinic.id + '/examens'))
                .then((response) => {
                  const examens = response.data
                  const newClinic = clinic
                  newClinic.examens = examens
                  resolve(newClinic) 
                }
              )
              })
            })).then((values) => {
              done(values)
            }
              
            )
            
          })
          .catch(failure);
        }
      }
    ]
  }

  getComponent(results) {
    return <ClinicListScene clinics={results.clinics} />
  }
}

export default ClinicListContainer;
